import RoutePath from '../constants/route-path';
import {DropdownIcon1} from "@/components/Icons/DropdownIcon1";
import {DropdownIcon2} from "@/components/Icons/DropdownIcon2";
import {DropdownIcon3} from "@/components/Icons/DropdownIcon3";
import {DropdownIcon4} from "@/components/Icons/DropdownIcon4";
import {DropdownIcon5} from "@/components/Icons/DropdownIcon5";
import {DropdownIcon6} from "@/components/Icons/DropdownIcon6";

export const unLoggedUserShoppingMenu = [
    {
        href: RoutePath.SignIn,
        translationKey: 'log-in'
    }
];

export const vipPartnerUserShoppingMenu = [
    {
        href: RoutePath.Products,
        translationKey: 'page.shop.title'
    },
    {
        href: RoutePath.Partners,
        translationKey: 'page.partners.title'
    },
];

export const loggedUserShoppingMenu = [
    {
        href: RoutePath.Products,
        translationKey: 'page.shop.title'
    },
    {
        href: RoutePath.Partners,
        translationKey: 'page.partners.title'
    },
];

export const adminShoppingMenu = [
    {
        href: RoutePath.Register,
        translationKey: 'page.join-us.title'
    },
    ...loggedUserShoppingMenu
];
